import Tooltip from "components/common/Tooltip/Tooltip";
import React from "react";

const VideoSVG = ({ color = "#7E7E7E" }) => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        // style={{ display: "flex" }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.694 2H3.30995C2.58756 2 2.00195 2.58561 2.00195 3.308V12.692C2.00195 13.4144 2.58756 14 3.30995 14H12.694C13.4163 14 14.002 13.4144 14.002 12.692V3.308C14.002 2.58561 13.4163 2 12.694 2Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.00195 2V14"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.002 2V14"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.00195 8H14.002"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.00195 5H5.00195"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.00195 11H5.00195"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.002 11H14.002"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.002 5H14.002"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default VideoSVG;
